import { render } from "./OrderPhotosViewer.vue?vue&type=template&id=ff5e7448&scoped=true"
import script from "./OrderPhotosViewer.vue?vue&type=script&lang=js"
export * from "./OrderPhotosViewer.vue?vue&type=script&lang=js"

import "./OrderPhotosViewer.vue?vue&type=style&index=0&id=ff5e7448&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff5e7448"]])

export default __exports__